<template>
    <div>
        <div class="row" v-if="element.type_user == this.userReceived">
            <div class="col-md-5 col-xs-7 card-message text-left">
                <div class="row">
                    <div class="col-12 text-name">
                        <strong><i>{{element.from}}</i></strong>
                    </div>
                    <div class="col-12 text-body">
                        <div v-if="element.attachment.length > 0">
                            <div v-if="checkExt(element.mediacontent) == this.type_attach_image">
                                <div class="div-attachment" v-on:click="showIngrandisci(element.attachment)">
                                    <img :src="element.attachment" class="p-2 img-attachment">
                                </div>
                            </div>
                            <div v-if="checkExt(element.mediacontent) == this.type_attach_other">
                                <div class="div-attachment mb-2">
                                    <a :href="element.attachment" target="_blank" class="link-attach">
                                        <ficon :icon="['fas', 'file-alt']" class="color-icon"></ficon>
                                        Visualizza
                                    </a>
                                </div>
                            </div>
                        </div>
                        <span v-html="element.body"></span>
                        <div v-if="element.type == this.type_message_audio || checkExt(element.mediacontent) == this.type_attach_audio">
                            <div class="row pt-2 pb-2 px-2">
                                <audio :src="element.attachment" controls></audio>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 text-right text-date">
                        <i>{{element.date_orig}}</i>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="element.type_user == this.userSent || element.type_user == this.userAutomatic">
            <div class="col-md-7 col-xs-5">

            </div>
            <div class="col-md-5 col-xs-7 card-message-self text-left">
                <div class="col-12 text-name">
                    <strong v-if="element.type_user == this.userSent"><i>{{element.from}}</i></strong>
                    <strong v-if="element.type_user == this.userAutomatic && element.delivery == 'kiri'"><i>Kiri</i></strong>
                    <strong v-if="element.type_user == this.userAutomatic && element.delivery != 'kiri'"><i></i></strong>
                </div>
                <div class="col-12 text-body">
                    <div v-if="element.attachment.length > 0">
                        <div v-if="checkExt(element.mediacontent) == this.type_attach_image">
                            <div class="div-attachment" v-on:click="showIngrandisci(element.attachment)">
                                <img :src="element.attachment" class="p-2 img-attachment">
                            </div>
                        </div>
                        <div v-if="checkExt(element.mediacontent) == this.type_attach_other">
                            <div class="div-attachment mb-2">
                                <a :href="element.attachment" target="_blank" class="link-attach">
                                    <ficon :icon="['fas', 'file-alt']" class="color-icon"></ficon>
                                    Visualizza
                                </a>
                            </div>
                        </div>
                    </div>
                   <span v-html="element.body"></span>
                   <div v-if="element.type == this.type_message_audio || checkExt(element.mediacontent) == this.type_attach_audio">
                        <div class="row pt-2 pb-2 px-2">
                            <audio :src="element.attachment" controls></audio>
                        </div>
                    </div>
                   
                </div>
                <div class="col-12 text-right text-date" v-if="element.date_read.length > 0">
                    <i>{{element.date_orig}} - Letto</i>
                </div>
                <div class="col-12 text-right text-date" v-if="element.date_read.length == 0">
                    <i>{{element.date_orig}} </i>
                </div>
            </div>
        </div>
        <b-modal id="modal-image" centered title="BootstrapVue" @shown="this.focusMyElement">
            <img src="" id="image-modal" class="img-fluid">
        </b-modal>
        <b-modal id="modal-1"></b-modal>

       
    </div>
</template>

<script>

    import defapp from "../models/defapp"
    import utilfunc from "../models/utilfunc"
    import MessageChat from '../models/MessageChat'

    export default {
        name: 'CardMessage',
        data: function() {
            return  {
                focusMyElement: false,
                userSent : defapp.TYPE_MESSAGE_SENT,
                userReceived : defapp.TYPE_MESSAGE_RECEIVED,
                userAutomatic : defapp.TYPE_MESSAGE_AUTOMATIC,
                type_attach_image : defapp.TYPE_ATTACH_IMAGE,
                type_attach_other : defapp.TYPE_ATTACH_OTHER,
                type_attach_audio : defapp.TYPE_ATTACH_AUDIO,
                type_message_vc : MessageChat.TYPE_VC_MESSGAE,
                type_message_controllo_linea : MessageChat.TYPE_MESSAGE_CONTROLLO_LINEA,
                type_message_audio: MessageChat.TYPE_AUDIO_MESSAGE,
            };
        },
        components: {    
            
        },
        props: ['element'],
        methods: {       
            showIngrandisci(url_image)
            {
                const h = this.$createElement
                // Using HTML string
                //const titleVNode = h('div', { domProps: { innerHTML: 'Title from <i>HTML<i> string' } })
                // More complex structure
                const messageVNode = h('div', { class: ['foobar'] }, [
               
                h('b-img', {
                    props: {
                    src: url_image,
                    thumbnail: true,
                    center: true,
                    fluid: true,
                    }
                })
                ])
                // We must pass the generated VNodes as arrays
                this.$bvModal.msgBoxOk([messageVNode], {
                    buttonSize: 'sm',
                    centered: true, 
                    size: 'lg'
                })
            },
            checkExt(path)
            {
                let util = new utilfunc()
                let result = util.getExtension(path)
                return result
            },
            
            
        },
        
        computed: function(){ 
           
        },
        mounted: function(){
        },
        created: function() {
        }
    }

</script>